<template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" fill="currentColor">
        <path d="M256 152.96L79.894 288.469v181.549h141.507V336.973h75.175v133.045h135.531V288.469z"/>
        <path d="M439.482 183.132V90.307h-74.166v35.77L256 41.982 0 238.919l35.339 45.936L256 115.062l220.662 169.794L512 238.92z"/>
    </svg>
</template>
